import * as React from "react";
import type { SVGProps } from "react";
const SvgIconLogoUnsplash = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path fill="#010101" d="M15 4.5H9v4h6zm-11 6h5v4h6v-4h5v9H4z" /></svg>;
export default SvgIconLogoUnsplash;